import { FeaturePermission } from '@enums';

export const PermissionActionsNames = {
  view: 'View',
  update: 'Update',
  remove: 'Remove',
  create: 'Create',
  download: 'Download',
  transfer: 'Transfer',
};
export const PermissionActionsValues = {
  true: 'allowed',
  false: 'disallowed',
};

export const PermissionFeaturesAlwaysView = [
  FeaturePermission.SubmissionCommon,
  FeaturePermission.SubmissionItem,
  FeaturePermission.SubmissionSample,
];
